export default __webpack_public_path__ + "static/media/LENS_CULINARIS_TEKAY_3.066a9075.jpg";